export default {
  inlineImagesOptions: {
    wordPressUrl: process.env.GATSBY_WP_URL,
    uploadsUrl: process.env.GATSBY_WP_URL + 'app/uploads',
  },
  cookieSettings: {
    path: '/',
    expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
    domain: process.env.GATSBY_COOKIE_DOMAIN,
  },
  lottiRenderSettings: {
    preserveAspectRatio: 'xMidYMid slice',

    filterSize: {
      width: '400%',
      height: '400%',
      x: '-200%',
      y: '-200%',
    },
  },
  languages: [
    {
      path: '/',
      local: 'de',
      code: 'de_DE',
    },
    {
      path: '/en',
      local: 'en',
      code: 'en_US',
    },
  ],
};
